import type { TourDefinition } from '../training/tours';

/**
 * Тур картки зустрічі. Ідентифікатор для реєстрації: 'meeting-card'.
 * Цілі — атрибути data-tour у картці зустрічі (features/meetings/card/*).
 */
export const MEETING_CARD_TOUR_ID = 'meeting-card';

export const MEETING_CARD_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Картка зустрічі',
  summary: 'Вхід до кімнати, згода на запис, гості й посилання, записи з розшифровкою, звіт ШІ-12 і доручення.',
  missingHint: 'Відкрийте картку зустрічі в розділі «Зустрічі» — підказки прив’яжуться до її розділів.',
  steps: [
    {
      id: 'join',
      target: 'meetings-join',
      title: 'Увійти до кімнати',
      body: 'ЄРС видає особисте посилання з токеном у момент входу: ведучий — модератор, працівники проходять повз лобі. Кімната відкривається у вебверсії або в застосунку Jitsi Meet.',
      placement: 'bottom',
    },
    {
      id: 'consent',
      target: 'meetings-consent',
      title: 'Згода на запис',
      body: 'Запис ведеться лише за політикою «за згодою»: погодилися всі гості й ніхто з учасників не відмовився. Рішення зберігається разом із текстом попередження.',
    },
    {
      id: 'guests',
      target: 'meetings-guests',
      title: 'Гості й посилання',
      body: 'Клієнт отримує персональне посилання з обмеженим строком і чекає в лобі, доки ведучий не впустить. Вилучення гостя відкликає посилання.',
    },
    {
      id: 'report',
      target: 'meetings-report',
      title: 'Звіт ШІ-12',
      body: 'Чернетка протоколу з розшифровки — модель ШІ або правила без моделі, з цитатами й часом. Перевірте позначені пункти й погодьте: звіт стане коментарем у пов’язаній задачі.',
    },
    {
      id: 'drafts',
      target: 'meetings-approve',
      title: 'Погодження ведучим',
      body: 'Звіт погоджує ведучий. Доручення «хто — що — строк» стають задачами лише після підтвердження у вкладці «Доручення» — без підтвердження нічого не створюється.',
    },
  ],
};

/** Короткий тур переліку зустрічей: створення зустрічі й календар. */
export const MEETINGS_LIST_TOUR_ID = 'meetings-list';

export const MEETINGS_LIST_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Зустрічі',
  summary: 'Найближчі й минулі зустрічі, календар, створення зустрічі з задачі, справи чи координації.',
  missingHint: 'Відкрийте розділ «Зустрічі».',
  steps: [
    {
      id: 'new',
      target: 'meetings-new',
      title: 'Нова зустріч',
      body: 'Зустріч можна створити тут або з картки задачі кнопкою «Зустріч». Тип визначає правила запису й шаблон звіту.',
      placement: 'bottom',
    },
    {
      id: 'views',
      target: 'meetings-views',
      title: 'Перелік і календар',
      body: 'Перелік показує найближчі зустрічі за часом і минулі; календар — місяць із зустрічами за днями.',
    },
    {
      id: 'list',
      target: 'meetings-list',
      title: 'Увійти в один клік',
      body: 'За 15 хвилин до початку біля зустрічі з’являється «Увійти». Для зустрічей, що тривають, — «Приєднатися».',
    },
  ],
};
